import { Const } from '../lib/const.cls'

export const mutations = {
	//trading-tool
	[Const.SET_SIGNAL_CENTRE](state, data) {
		try { state.signalCentre = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_AUTO_CHARTIST](state, data) {
		try { state.autoChartist = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_CURRENT_NEWS](state, data) {
		try { state.currentNews = data } catch (ex) { console.debug('set state EX', ex) }
	},

	[Const.SET_COUPON_LIST](state, data) {
		try { state.couponlist = data } catch (ex) { console.debug('set state EX', ex) }
	},

	[Const.SET_ECONOMIC_CALENDER_DATA](state, data) {
		try { state.economicCalData = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_SUB_PLAN_LIST](state, data) {
		try { state.subPlanList = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_SUB_PLAN_DETAIL](state, data) {
		try { state.sunPlanDetail = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_VPS_LIST](state, data) {
		try { state.vpsList = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_VPS_DETAIL](state, data) {
		try { state.vpsDetail = data } catch (ex) { console.debug('set state EX', ex) }
	},

	//user
	[Const.SET_USER_PROFILE](state, data) {
		try { state.userProfile = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_USER_NOTIFICATIONS](state, data) {
		try { state.userNotify = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_COUNTRIES_LIST](state, data) {
		try { state.countriesList = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_CITIES_LIST](state, data) {
		try { state.citiesList = data } catch (ex) { console.debug('set state EX', ex) }
	},

	//support
	[Const.SET_TICKET_LIST](state, data) {
		try { state.ticketList = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_TICKET_VIEW](state, data) {
		try { state.ticketView = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_TICKET_REASON_LIST](state, data) {
		try { state.ticketReasonList = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_TICKET_DATA](state, data) {
		try { state.ticketData = data } catch (ex) { console.debug('set state EX', ex) }
	},

	//trading accounts
	[Const.SET_TRADING_ACCOUNT_LIST](state, data) {
		try { state.tradingAccountList = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_LIVE_ACCOUNT_LIST](state, data) {
		try { state.liveAccountList = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_DEMO_ACCOUNT_LIST](state, data) {
		try { state.demoAccountList = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_ACCOUNT_DETAILS](state, data) {
		try { state.accountDetails = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_LAST_SELECT_TRADING_ACCOUNT](state, data) {
		try { state.lastSelectTradingAccount = data } catch (ex) { console.debug('set state EX', ex) }
	},

	//deposit
	[Const.SET_DEPOSIT_LIST](state, data) {
		try { state.depositList = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_DEPOSIT_LIMIT](state, data) {
		try { state.deposit_limit = data } catch (ex) { console.debug('set state EX', ex) }
	},

	//withdrawal
	[Const.SET_WITHDRAWAL_LIST](state, data) {
		try { state.withdrawalList = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_WITHDRAWAL_METHOD_RESPONSE](state, data) {
		try { state.withdrawalMethodResponse = data } catch (ex) { console.debug('set state EX', ex) }
	},

	[Const.SET_WITHDRAWAL_METHOD_RESPONSE_DEP](state, data) {
		try { state.withdrawalMethodResponseDep = data } catch (ex) { console.debug('set state EX', ex) }
	},

	//bonus
	[Const.SET_BONUS_LIST](state, data) {
		try { state.bonusList = data } catch (ex) { console.debug('set state EX', ex) }
	},

	//bank
	[Const.SET_BANK_LIST](state, data) {
		try { state.bankList = data } catch (ex) { console.debug('set state EX', ex) }
	},

	[Const.SET_HOOPS_DATA](state, data) {
		try { state.hoopsData = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_VIDEO_TUTORIAL](state, data) {
		try { state.VIDEO_TUTORIAL = data } catch (ex) { console.debug('set state EX', ex) }
	},
}



// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/mutations.js